<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Order Name" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a href="#tab_2" data-toggle="tab" aria-expanded="true">Items</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_DOCUMENT }" v-if="formData.payment_type == 'Transfer'"><a @click="onClickTabDocument()" href="#tab_3" data-toggle="tab" aria-expanded="true">Documents</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputEmail" class="col-sm-4 control-label">Email</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputEmail" placeholder="" v-model="formData.email">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTotalAmount" class="col-sm-4 control-label">Total Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputTotalAmount" placeholder="" v-model="formData.total_amount" ref="totalAmount">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputFirstName" class="col-sm-4 control-label">First Name</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputFirstName" placeholder="" v-model="formData.first_name" ref="firstName">
                              </div>
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCurrency" class="col-sm-4 control-label">Currency</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputCurrency" placeholder="" v-model="formData.currency_name">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLastName" class="col-sm-4 control-label">Last Name</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputLastName" placeholder="" v-model="formData.last_name" ref="lastName">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProject" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputProject" placeholder="" v-model="formData.project_name">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPhone" class="col-sm-4 control-label">Phone</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputPhone" placeholder="" v-model="formData.phone" ref="phone">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProcessDate" class="col-sm-4 control-label">Process Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputProcessDate" placeholder="" v-model="formData.process_date">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputDescription" class="col-sm-4 control-label">Description</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputDescription" placeholder="" v-model="formData.description">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputBookingDate" class="col-sm-4 control-label">Booking Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="true" class="form-control" id="inputBookingDate" placeholder="" v-model="formData.booking_date">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputStatus" class="col-sm-4 control-label">Status</label>
                              <div class="col-md-8">
                                <select v-model="formData.status" class="form-control" :disabled="viewMode != MODE_UPDATESTATUS ? true : false">
                                  <option v-for="(row, i) in listStatus" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>                     
                            </div>
                          </div>
                        </div>                                                   
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                            <!-- <label for="recordPerPageItem" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                            <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                              <select @change="changePageSizeItem($event)" ref="recordPerPageItem" class="form-control">
                                <option v-if="inquiryItemParam.pageSize == 5" selected>5</option><option v-else>5</option>
                                <option v-if="inquiryItemParam.pageSize == 10" selected>10</option><option v-else>10</option>
                                <option v-if="inquiryItemParam.pageSize == 20" selected>20</option><option v-else>20</option>
                                <option v-if="inquiryItemParam.pageSize == 50" selected>50</option><option v-else>50</option>
                                <option v-if="inquiryItemParam.pageSize == 100" selected>100</option><option v-else>100</option>
                              </select>
                            </div>          
                            <div class="box-tools">              
                              <button v-on:click="inquiryItem" class="btn btn-warning">Search</button>
                            </div> -->
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <!-- <th style="width:85px;text-align:center;">Action</th> -->
                                <th style="text-align:left;">ID</th>
                                <th style="text-align:left;">Name</th>
                                <th style="text-align:right;">Quantity</th>
                                <th style="text-align:right;">Price</th>
                                <th style="text-align:right;">Amount</th>
                                <th style="text-align:center;">Currency</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listItem" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceItem + i + 1}}</td>
                                <!-- <td style="width:85px;text-align:center;">
                                  <a href="#" v-on:click="onDisplayItem(row)" ref="displayRow" style="padding-right:5px">
                                    <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display Item"></span>
                                  </a>
                                </td>                                 -->
                                <td style="text-align:left;" nowrap>{{ row.item_id }}</td>
                                <td style="text-align:left;">{{ row.name }}</td>
                                <td style="text-align:right;">{{ row.quantity }}</td>
                                <td style="text-align:right;">{{ row.price }}</td>
                                <td style="text-align:right;">{{ row.amount }}</td>
                                <td style="text-align:center;">{{ row.currency_name }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.order_id }}</td>
                                <td hidden>{{ row.currency_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                          <!-- <div class="form-group">
                            <label style="width:25px;text-align:right;">
                                <a href="#"><i @click="changePageItem(1)" class="icon ion-ios-rewind"></i></a>
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePageItem(inquiryItemParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                            </label>
                            <label>
                                Page
                            </label>
                            <label>
                                <input v-model="inquiryItemParam.CurrentPageNumber" v-on:keyup.enter="gotoPageItem($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                            </label>
                            <label id="TotalPageText">
                              {{ totalPagesItem }}                
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePageItem(inquiryItemParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                            </label>
                            <label style="width:25px;text-align:left;">
                                <a href="#"><i @click="changePageItem(totalPagesItem)" class="icon ion-ios-fastforward"></i></a>
                            </label>
                          </div> -->
                        </div>                        
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_DOCUMENT }" class="tab-pane" id="tab_3">
                        <div class="col-md-12">
                          <div class="box no-border">                             
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Action</th>
                                    <th style="text-align:left;">Name</th>
                                    <th style="text-align:left;">Document</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listDocument" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td class="text-nowrap" style="text-align:center;">
                                      <a href="#" v-on:click="onDisplayDocument(row)" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>                                                                  
                                    </td>
                                    <td class="text-nowrap" style="text-align:left;">{{ row.name }}</td>
                                    <td style="text-align:left;"><a href="#" @click="getDocumentImage(row.id)">{{ row.imageUrl }}</a></td>                                     
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>                     
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" v-model="formData.id">
              <input type="hidden" class="form-control" v-model="formData.projectId">
              <input type="hidden" class="form-control" v-model="formData.company_id">
              <input type="hidden" class="form-control" v-model="formData.currency_id">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>                
                <button v-if="viewMode == MODE_UPDATESTATUS" @click="onCancel()" class="btn btn-warning pull-right">Cancel</button>    
                <button v-if="viewMode == MODE_UPDATESTATUS" @click="onSave()" class="btn btn-info pull-right" style="margin-right:15px;">Save</button>
                <button v-if="viewMode == MODE_UPDATE" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>                            
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const MODE_UPDATESTATUS = 'updatestatus'
const TAB_OVERVIEW = 'tabOverview'
const TAB_ITEMS = 'tabItems'
const TAB_DOCUMENT = 'tabDocument'

export default {
  name: 'PaymentOrderForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      MODE_UPDATESTATUS: MODE_UPDATESTATUS,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_ITEMS: TAB_ITEMS,
      TAB_DOCUMENT: TAB_DOCUMENT,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        description: '',
        total_amount: 0,
        currency_id: 0,
        company_id: 0,
        company_name: '',
        project_id: 0,
        project_name: '',
        process_date: '',
        booking_date: '',
        status: '',
        payment_type: ''
      },
      listDocument: null,
      listData: [],
      formDocument: {
        id: 0,
        name: '',
        imageUrl: '',
        picture: null
      },
      listItem: null,
      listStatus: [
        { id: 'Draft', name: 'Draft' },
        { id: 'Cancel', name: 'Cancel' },
        { id: 'Paid', name: 'Paid' }
      ],
      // totalRowsItem: 0,
      // totalPagesItem: 0,
      startSequenceItem: 0,
      startSequence: 0,
      inquiryItemParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        pageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'CreatedDate'
      },
      tabActive: '',
      originalcallback: ''
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    updateDateField() {
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
    },
    getDetail() {
      var localUserString = window.localStorage.getItem('user') || 'null'
      var localUser = JSON.parse(localUserString)
      // Find object with authObjectName 'EditOrder' in authObject array
      let editOrderObj = null
      if (localUser && localUser.authorizationProfile && Array.isArray(localUser.authorizationProfile.authObject)) {
        editOrderObj = localUser.authorizationProfile.authObject.find(obj => obj.authObjectName === 'EditOrder')
      }
      if (editOrderObj) {
        if (editOrderObj.value === 'true') {
          this.viewMode = MODE_UPDATE
        } else {
          this.viewMode = MODE_VIEW
        }
      } else {
        this.viewMode = MODE_VIEW
      }
      api
        .request('Payment', 'get', '/api/Payment/GetDetailOrder?Id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
          this.listItem = data.entity.order_items
          this.updateDateField()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.first_name = ''
      this.formData.last_name = ''
      this.formData.email = ''
      this.formData.phone = ''
      this.formData.description = ''
      this.formData.total_amount = 0
      this.formData.currency_id = 0
      this.formData.company_id = 0
      this.formData.company_name = ''
      this.formData.project_id = 0
      this.formData.project_name = ''
      this.formData.process_date = ''
      this.formData.booking_date = ''
      this.formData.status = ''
      this.formData.payment_type = ''
      this.updateDateField()
    },
    onClickTabDocument() {
      api
        .request('Guest', 'get', '/api/GuestDocument/Inquiry?WhereClause=Name=\'' + this.formData.id + '\'&PageSize=10&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Name', null)
        .then(response => {
          var resData = response.data
          this.listDocument = resData.entity
          // console.log(this.listDocument)
        })
        .then(response => {
          // this.listDocument.forEach(item => {
          //   this.toDataURL('/image/GuestDocument/' + item.imageUrl, function(dataUrl) {
          //     item.picture = dataUrl
          //     item.imageUrl = ''
          //   })
          // })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getDocumentImageUrl(id) {
      return api.getBaseUrl('Guest', '/api/GuestDocument/GetImageDocument?Id=' + id)
    },
    getDocumentImage(id) {
      SweetAlert.fire({
        title: '',
        html: '<img src="' + this.getDocumentImageUrl(id) + '" class="img-responsive img-thumbnail">',
        // type: 'info',
        showCancelButton: false,
        // confirmButtonText: 'Continue',
        // cancelButtonText: 'Cancel',
        // showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
      })
    },
    onEdit(formData) {
      this.viewMode = MODE_UPDATESTATUS
      this.formData.id = formData.id
      this.formData.name = formData.name
      this.formData.email = formData.email
      this.formData.first_name = formData.first_name
      this.formData.last_name = formData.last_name
      this.formData.phone = formData.phone
      this.formData.description = formData.description
      this.formData.total_amount = formData.total_amount
      this.formData.company_id = formData.company_id
      this.formData.company_name = formData.company_name
      this.formData.project_id = formData.project_id
      this.formData.project_name = formData.project_name
      this.formData.booking_date = formData.booking_date
      this.formData.process_date = formData.process_date
      this.formData.status = formData.status
      this.formData.payment_type = formData.payment_type
      this.updateDateField()
    },
    onCancel() {
      this.getDetail()
      this.viewMode = MODE_VIEW
    },
    onSave() {
      let reqData = {
        id: this.formData.id,
        name: this.formData.name,
        email: this.formData.email,
        first_name: this.formData.first_name,
        last_name: this.formData.last_name,
        phone: this.formData.phone,
        company_id: this.formData.company_id,
        company_name: this.formData.company_name,
        project_id: this.formData.project_id,
        project_name: this.formData.project_name,
        status: this.formData.status
      }

      let status = 'success'
      let message = ''
      api
        .request('Payment', 'post', '/api/Payment/UpdateOrderStatus', reqData)
        .then(async response => {
          let resData = response.data
          let msgReserve = ''
          let msgPasscode = ''
          if (this.formData.status === 'Paid' || this.formData.status === 'Cancel') {
            msgReserve = await this.onSaveReserve()
            if (this.formData.status === 'Paid') {
              msgPasscode = await this.onGeneratePasscode(reqData)
            }
          }
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message + '<br>' + msgReserve + '<br>' + msgPasscode, status)
          this.formData.id = resData.entity.id
        })
        .then(response => {
          this.getDetail()
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })

      this.viewMode = MODE_UPDATE
    },
    async onSaveReserve() {
      let message = ''
      const myObject = JSON.parse(this.formData.description)
      // Remove square brackets from no_reservation string if present
      if (typeof myObject.no_reservation === 'string') {
        myObject.no_reservation = myObject.no_reservation.replace(/\[|\]/g, '')
        myObject.no_reservation = myObject.no_reservation.split(',')
      }
      if (!Array.isArray(myObject.no_reservation)) {
        myObject.no_reservation = []
      }
      console.log(myObject.no_reservation)
      for (var i = 0; i < myObject.no_reservation.length; i++) {
        let idReservation = myObject.no_reservation[i].trim()
        let reqData = await api
          .request('Reservation', 'get', '/api/Reservation/' + idReservation, null)
          .then(response => {
            return response.data.entity
          })
        // console.log(reqData)
        reqData.status = this.formData.status === 'Paid' ? 'Confirmed' : 'Canceled'
        message = await api
          .request('Reservation', 'put', '/api/Reservation', reqData)
          .then(response => {
            let resData = response.data
            // status = resData.returnStatus ? 'success' : 'error'
            return resData.returnMessage.join('<br>')
            // console.log(message)
          })
      }
      this.viewMode = MODE_VIEW
      return message
    },
    async onGeneratePasscode() {
      var localUserString = window.localStorage.getItem('user') || 'null'
      var localUser = JSON.parse(localUserString)
      this.listData = await api.request('Payment', 'get', "/api/Payment/Inquiry?WhereClause=order_id = '" + this.formData.id + "'&PageSize=10&CurrentPageNumber=1&SortDirection=ASC&SortExpression=order_id", null)
        .then(response => {
          var data = response.data
          return data.entity[0]
        })
        .catch(error => {
          return error
        })

      let reqData = {
        status_code: '200',
        status_message: 'Manual Update Payment notification By UserId' + localUser.id,
        transaction_id: this.formData.name,
        order_id: this.listData.id,
        gross_amount: this.formData.total_amount,
        payment_type: this.formData.payment_type,
        transaction_time: this.formData.process_date,
        transaction_status: 'settlement',
        fraud_status: '',
        signature_key: this.formData.name
      }
      let passcode = await api
        .request('Payment', 'post', '/api/Payment/Notification', reqData)
        .then(async response => {
          return response.data
        })
      console.log(passcode)
      return passcode.returnStatus === true ? passcode.returnMessage[0] : ''
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.originalcallback
      }
      this.$router.push({ name: this.callback, params: params })

      // this.$route.meta.breadcrumb.pop()
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentOrderForm.vue?3ec71097